import { Box, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ItemDetails } from 'components'
import { useIsSmallScreen } from 'packages/core'
import { CommonAttributes } from '../CommonAttributes'
import DomPurify from 'dompurify'
import ReactHtmlParser from 'react-html-parser'
import InfoBoxWithIcon from 'components/common/InfoBoxWithIcon'
const PaddedDiv = styled(Box)({
    padding: '0 31px',
})
const attributeValueStyleProps = {
    fontSize: '13px !important',
}
const labelProps = {
    fontWeight: 'bold',
}

export const OverviewSection = ({ credential }: any) => {
    const { t } = useTranslation()
    const parsedHtml = ReactHtmlParser(
        DomPurify.sanitize(credential?.instructions),
    )

    const attributeOrientation = useIsSmallScreen() ? 'vertical' : 'horizontal'

    return (
        <ItemDetails.AttributesContainer
            data-ai-explain="Credential overview: identity, account, type, directory, default and maximum checkout durations, description, access policy when shown, and any published instructions."
        >
            <PaddedDiv>
                <ItemDetails.Attribute
                    label={t('Common_DisplayName')}
                    value={credential.friendlyName}
                    orientation={attributeOrientation}
                    valueProps={attributeValueStyleProps}
                    labelProps={labelProps}
                />

                <ItemDetails.Attribute
                    label={t('Credentials_AccountLogonName')}
                    value={credential.checkedOutByLogin}
                    orientation={attributeOrientation}
                    valueProps={attributeValueStyleProps}
                    labelProps={labelProps}
                />
                <ItemDetails.Attribute
                    label={t('CredentialsType')}
                    value={credential.typeName}
                    orientation={attributeOrientation}
                    valueProps={attributeValueStyleProps}
                    labelProps={labelProps}
                />
                <ItemDetails.Attribute
                    label={t('Common_DomainOrDirectory')}
                    value={credential.resourceSystemFriendlyName}
                    orientation={attributeOrientation}
                    valueProps={attributeValueStyleProps}
                    labelProps={labelProps}
                />

                <ItemDetails.Attribute
                    label={t('DefaultAccessDurationInMinutes')}
                    value={credential.defaultCheckOutTimeMinutes}
                    orientation={attributeOrientation}
                    valueProps={attributeValueStyleProps}
                    labelProps={labelProps}
                />

                <ItemDetails.Attribute
                    label={t('MaxAccessDurationInMinutes')}
                    value={credential.maxCheckOutTimeMinutes}
                    orientation={attributeOrientation}
                    valueProps={attributeValueStyleProps}
                    labelProps={labelProps}
                />

                <ItemDetails.Attribute
                    label={t('Common_Description')}
                    value={credential.description}
                    orientation={attributeOrientation}
                    valueProps={attributeValueStyleProps}
                    labelProps={labelProps}
                />
                <CommonAttributes resource={credential} />
                {parsedHtml && parsedHtml.length > 0 && (
                    <InfoBoxWithIcon
                        iconName={'InfoNew'}
                        message={parsedHtml}
                        rootStyles={{
                            width: '100%',
                            marginTop: '2.8rem',
                            marginBottom: '1.8rem',
                        }}
                    />
                )}
            </PaddedDiv>
        </ItemDetails.AttributesContainer>
    )
}
